import React from "react";
import AdvancedSearchInputBox from "../AdvancedSearchInput/AdvancedSearchInputBox";

const DualInputField = ({ label, fieldPrefix, placeholder1, placeholder2, searchData, handleChange }) => {
    return (
        <div className='w-[170px] mr-2'>
            <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>{label}</p>
            <div className='w-full flex items-center'>
                <AdvancedSearchInputBox
                    label={""}
                    placeholder={placeholder1}
                    id={fieldPrefix}
                    data_testid={fieldPrefix}
                    htmlFor={fieldPrefix}
                    value={searchData?.[fieldPrefix]}
                    handleOnChangeInput={handleChange}
                    maxLength={60}
                />
                <span className='mx-1 text-xs font-normal text-[#000000]'>@</span>
                <AdvancedSearchInputBox
                    label={""}
                    placeholder={placeholder2}
                    id={`${fieldPrefix}_domain`}
                    data_testid={`${fieldPrefix}_domain`}
                    htmlFor={`${fieldPrefix}_domain`}
                    value={searchData?.[`${fieldPrefix}_domain`]}
                    handleOnChangeInput={handleChange}
                    maxLength={60}
                />
            </div>
        </div>
    );
};

export default DualInputField;
